<section class="bg-gray-50 dark:bg-gray-900">
    <div class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
        <div
            class="w-full p-6 bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md dark:bg-gray-800 dark:border-gray-700 sm:p-8">
            <h2 class="mb-1 text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                Change Password
            </h2>
            <form class="mt-4 space-y-4 lg:mt-5 md:space-y-5" (ngSubmit)="onSubmit()">
            <div>
                <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    New Password
                </label>
                <input [(ngModel)]="password" (ngModelChange)="validatePassword()" type="password" name="password" id="password"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg 
                                             focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 
                                             dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 
                                             dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
                <p *ngIf="passwordError" class="text-red-600 text-sm">{{ passwordError }}</p>
            </div>
            <div>
                <label for="confirm-password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Confirm Password
                </label>
                <input [(ngModel)]="confirmPassword" (ngModelChange)="validateConfirmPassword()" type="password"
                    name="confirm-password" id="confirm-password" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg 
                                               focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 
                                               dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 
                                               dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
                <p *ngIf="confirmPasswordError" class="text-red-600 text-sm">{{ confirmPasswordError }}</p>
            </div>

                <!-- Validation error message -->
                <p *ngIf="validationError" class="text-red-600 text-sm">
                    {{ validationError }}
                </p>

                <button type="submit" class="btn btn-secondary">
                    Reset Password
                </button>
            </form>
        </div>
    </div>
</section>